import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=0c38baac&scoped=true"
import script from "./CharacterDetail.vue?vue&type=script&lang=ts"
export * from "./CharacterDetail.vue?vue&type=script&lang=ts"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=0c38baac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38baac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c38baac')) {
      api.createRecord('0c38baac', component.options)
    } else {
      api.reload('0c38baac', component.options)
    }
    module.hot.accept("./CharacterDetail.vue?vue&type=template&id=0c38baac&scoped=true", function () {
      api.rerender('0c38baac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CharacterDetail.vue"
export default component.exports